import React, {FunctionComponent} from "react";
import {IppodromItem} from "/src/domain/challenges/ChallengeProtocolData";
import makeStyles from "@mui/styles/makeStyles";
import cs from "classnames";
import {theme} from "/src/assets/theme";
import {useTranslation} from "react-i18next";
import {Grid} from "@mui/material";
import {IppodromRecordView} from "/src/ui/challengeProtocol/ippodrom/IppodromRecordView";

export type IppodromViewProps = {
    items: IppodromItem[],
    className?: string
}

type ClassNamed = {
    className?: string;
}

export const IppodromView: FunctionComponent<IppodromViewProps> = ({items, className}) => {
    const classes = useStyles();

    if (items.length == 0) return null;

    return (
        <div className={cs(classes.container, className)}>
            <Header itemsCount={items.length}/>
            <TableHeader/>
            {items.map(i => (
                <div key={i.participant.id} className={classes.participantBlock}>
                    <IppodromRecordView
                        item={i}
                    />
                </div>
            ))}
        </div>
    )
}

type HeaderProps = {
    className?: string;
    itemsCount: number;
}

const Header: FunctionComponent<HeaderProps> = ({className, itemsCount}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    return (<div className={cs(classes.header, className)}>
        {`${t('scoreFinishProtocol')} (${itemsCount})`}
    </div>)
}

const TableHeader: FunctionComponent<ClassNamed> = ({
                                                        className
                                                    }) => {
    const {t} = useTranslation();
    const classes = useStyles();

    return (
        <Grid container
              className={cs(classes.tableHeader, className)}
              justifyContent="center"
              alignItems="center"
        >
            <Grid item container xs={11} spacing={1}>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={1} container justifyContent="center" style={{paddingLeft: 0}}
                      className={classes.tableHeaderCell}>
                    #
                </Grid>
                <Grid item xs={8} className={classes.tableHeaderCell}>
                    {t('name')}
                </Grid>
                <Grid item container xs={2} justifyContent="flex-end" className={classes.tableHeaderCell}>
                    {t('score')}
                </Grid>
            </Grid>
        </Grid>
    );
};

const useStyles = makeStyles((muiTheme) => ({
    container: {
        paddingBottom: "1.5rem",
    },
    participantBlock: {
        color: theme.primaryColor,
        "&:nth-child(even)": {
            backgroundColor: theme.lightPrimaryColor,
        },
    },
    trainerBanner: {
        marginTop: "1rem",
    },
    header: {
        backgroundColor: theme.lightSecondaryColor,
        padding: '0.5rem 1.5rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        textAlign: 'start',
        lineHeight: '1rem',
        color: theme.secondaryColor,
    },
    tableHeaderCell: {
        overflowX: 'auto',
    },
    tableHeader: {
        width: '100%',
        margin: 0,
        height: '2.5rem',
        marginTop: '0.5rem',
        fontSize: '0.9rem',
        fontWeight: 500,
        color: muiTheme.palette.primary.main,
        padding: '0.5rem 0',
    }
}));